import { addWeeks } from 'date-fns';
import { DEFAULT_EXPERIMENT_WEEKS } from '../constants/experiments';

const isDayjsInstance = (value) => Boolean(value && typeof value === 'object' && typeof value.add === 'function' && typeof value.toDate === 'function');

const toDate = (value) => {
  if (!value) return null;
  if (value instanceof Date) {
    return new Date(value.getTime());
  }
  if (isDayjsInstance(value)) {
    const asDate = value.toDate();
    return Number.isNaN(asDate?.getTime()) ? null : asDate;
  }
  const asDate = new Date(value);
  return Number.isNaN(asDate.getTime()) ? null : asDate;
};

export const computeDefaultEndDate = (startDate) => {
  if (!startDate) return null;
  if (isDayjsInstance(startDate)) {
    return startDate.add(DEFAULT_EXPERIMENT_WEEKS, 'week');
  }
  const start = toDate(startDate);
  if (!start) return null;
  return addWeeks(start, DEFAULT_EXPERIMENT_WEEKS);
};

export const calculateDurationWeeks = (startDate, endDate) => {
  const start = toDate(startDate);
  const end = toDate(endDate);
  if (!start || !end) return null;
  const diffMs = end.getTime() - start.getTime();
  if (diffMs < 0) return null;
  const weeks = diffMs / (7 * 24 * 60 * 60 * 1000);
  return Number.isFinite(weeks) ? weeks : null;
};

export const formatWeeksDisplay = (weeks) => {
  if (weeks == null) return null;
  const rounded = Math.round(weeks * 10) / 10;
  if (!Number.isFinite(rounded) || rounded < 0) return null;
  const asInt = Math.trunc(rounded);
  return Number.isInteger(rounded) ? asInt : rounded;
};

export default {
  computeDefaultEndDate,
  calculateDurationWeeks,
  formatWeeksDisplay,
};
